import { Link, useLocation } from "react-router-dom";
import { Car, Menu, X, MessageCircle } from "lucide-react";
import { useState } from "react";
import { Button } from "./ui/button";

const WHATSAPP_NUMBER = process.env.REACT_APP_WHATSAPP_NUMBER || "+390571902390";

export const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();

  const links = [
    { href: "/", label: "Home" },
    { href: "/catalogo", label: "Catalogo" },
  ];

  const isActive = (path) => location.pathname === path;

  return (
    <nav className="sticky top-0 z-50 bg-white text-zinc-900 shadow-sm" data-testid="navbar">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="flex items-center gap-3 group" data-testid="logo-link">
            <img 
              src="https://customer-assets.emergentagent.com/job_auto-feed-importer/artifacts/jqtpdh6n_CAVW_Logo.PNG"
              alt="CAVW Logo"
              className="h-10"
            />
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center gap-8">
            {links.map((link) => (
              <Link
                key={link.href}
                to={link.href}
                data-testid={`nav-link-${link.label.toLowerCase()}`}
                className={`text-sm font-semibold uppercase tracking-wider transition-colors duration-200 ${
                  isActive(link.href)
                    ? "text-blue-600"
                    : "text-zinc-600 hover:text-zinc-900"
                }`}
              >
                {link.label}
              </Link>
            ))}
            <a
              href={`https://wa.me/${WHATSAPP_NUMBER.replace('+', '')}?text=${encodeURIComponent('Ciao, vorrei informazioni sulle auto disponibili.')}`}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="nav-whatsapp-btn"
            >
              <Button className="bg-green-600 hover:bg-green-700 text-white font-semibold uppercase tracking-wide text-sm">
                <MessageCircle className="w-4 h-4 mr-2" />
                Contattaci
              </Button>
            </a>
          </div>

          {/* Mobile Menu Button */}
          <Button
            variant="ghost"
            size="icon"
            className="md:hidden text-zinc-900 hover:bg-zinc-100"
            onClick={() => setIsOpen(!isOpen)}
            data-testid="mobile-menu-button"
          >
            {isOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </Button>
        </div>

        {/* Mobile Navigation */}
        {isOpen && (
          <div className="md:hidden pb-4 border-t border-zinc-200 mt-2 pt-4" data-testid="mobile-menu">
            {links.map((link) => (
              <Link
                key={link.href}
                to={link.href}
                onClick={() => setIsOpen(false)}
                className={`block py-3 text-sm font-semibold uppercase tracking-wider ${
                  isActive(link.href)
                    ? "text-blue-600"
                    : "text-zinc-600"
                }`}
              >
                {link.label}
              </Link>
            ))}
            <a
              href={`https://wa.me/${WHATSAPP_NUMBER.replace('+', '')}?text=${encodeURIComponent('Ciao, vorrei informazioni sulle auto disponibili.')}`}
              target="_blank"
              rel="noopener noreferrer"
              className="block mt-3"
            >
              <Button className="w-full bg-green-600 hover:bg-green-700 text-white font-semibold uppercase tracking-wide text-sm">
                <MessageCircle className="w-4 h-4 mr-2" />
                Contattaci
              </Button>
            </a>
          </div>
        )}
      </div>
    </nav>
  );
};

export default Navbar;
